var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFallbackImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 80,
  height: 112,
  viewBox: "0 0 80 112"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M49 63V49c0-1.1-.9-2-2-2H33c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-12.1-5.02l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68a.5.5 0 0 1-.4.8H34.02c-.42 0-.65-.48-.39-.81l2.49-3.2c.19-.26.57-.27.78-.02z"
})));
export default SvgFallbackImage;